namespace $ {
	/**
	 * Decorates method to fiber to ensure it is executed only once inside other fiber from [mol_wire](../wire/README.md)
	 * @see https://mol.hyoo.ru/#!section=docs/=1fcpsq_1wh0h2
	 */
	export let $mol_action = $mol_wire_method
}
